import Swup from "swup";
import SwupScriptsPlugin from "@swup/scripts-plugin";
import SwupScrollPlugin from "@swup/scroll-plugin";
import SwupBodyClassPlugin from '@swup/body-class-plugin';
// import SwupFadeTheme from '@swup/fade-theme';
import SwupPreloadPlugin from '@swup/preload-plugin';
// import SwupFormsPlugin from '@swup/forms-plugin';
import SwupGaPlugin from '@swup/ga-plugin';

export default function (container) {
  const swup = new Swup({
    containers: [container],
    plugins: [
      new SwupScriptsPlugin({ optin: true }),
      new SwupScrollPlugin({ animateScroll: false, doScrollingRightAway: true }),
      new SwupBodyClassPlugin(),
      // new SwupFadeTheme({ mainElement: '#main-content' }),
      new SwupPreloadPlugin(),
      // new SwupFormsPlugin(),
      new SwupGaPlugin()
    ],
    animateHistoryBrowsing: true,
    linkSelector: `a[href^="${window.location.origin}"]:not([data-no-swup]):not(.glightbox), a[href^="/"]:not([data-no-swup]):not(.glightbox), a[href^="#"]:not([data-no-swup]):not(.glightbox)`
    });
  return swup;
}
